module.exports = __webpack_public_path__ + "ring.png?c233cb8bd810849445f205f599b563f9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ring.png
// module id = 18
// module chunks = 0